import "./job.css";
// import facult1 from '../../images/faculty1.png';
import React, { useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { vacancydata } from "../../data";
import { BsBookmark } from "react-icons/bs";
import { AiOutlineShareAlt } from "react-icons/ai";
import { GoLocation } from "react-icons/go";
import { TbTie } from "react-icons/tb";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from "mdb-react-ui-kit";
import Form from "react-bootstrap/Form";
import { useEffect } from "react";
import axios from "axios";
import { Link, Navigate, NavLink } from "react-router-dom";
import { baseUrl } from "../../context/BaseUrl";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import parse from "html-react-parser";

const Job = (props) => {
  //for popup
  const [toggleOneModal, setToggleOneModal] = useState(false);
  const [toggleTwoModal, setToggleTwoModal] = useState(false);

  const SaveVacancy = async (value) => {
    try {
      const val = localStorage.getItem("user");

      if (!val) {
        toast.error("You are not logged in!!");

        return;
      }
      const user = JSON.parse(val);
      const token = user.token;

      const data = {
        vacancy_id: value,
        user_id: user.user._id,
      };
      const response = await fetch(
        `${baseUrl}/user/user_rights/postvacancy/${user.user._id}`,
        {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(data),
        }
      );
      const result = await response.json();
      //   alert(result);
      if (result) {
        if (result.error == 500) {
          toast.error(result.msg);
        }
        toast.success(result.msg);

        fetchData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#05A474" }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block", background: "#05A474" }}
        onClick={onClick}
      />
    );
  }

  const settings = {
    dots: false,
    infinite: false,
    autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    loop: true,
    margin: 10,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1260,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          autoplay: true,
          speed: 300,
          loop: true,
          margin: 10,
        },
      },
      {
        breakpoint: 1380,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          autoplay: true,
          speed: 300,
          loop: true,
          margin: 10,
        },
      },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            autoplay: true,
            speed: 300,
            loop: true,
            margin: 10,
        },
      },
      
      
    ],
    
  };

  const [Data, setData] = useState(null);

  async function fetchData() {
    try {
      const response = await axios.get(
        `${baseUrl}/user/institute/getinstitute/${props.id}`
      );
      console.log("job______", response.data);
      setData(response.data);
    } catch (error) {
      console.error(error);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    Data !== null && (
      <>
        <ToastContainer />
        <div className="job-slider">
          <div className="job-card-container-pc d-none d-lg-block">
            <Slider {...settings}>
              {Data.vacancy.map((val, key) => {
                return (
                  <div className="slide-main" key={key}>
                    <div className="job-card">
                      <div className="top d-flex">
                        <h6>{val.name[0]}</h6>
                        <p>
                          <button
                            className="bg-white text-black"
                            onClick={() => SaveVacancy(val._id)}
                          >
                            <BsBookmark />
                          </button>
                        </p>
                      </div>
                      <h5 style={{ height: "50px" }}>{val.name}</h5>
                      <div className="center d-flex">
                        <p>
                          <GoLocation /> {val.location}
                        </p>
                        <p>
                          <TbTie /> Full Time
                        </p>
                      </div>
                      <p className="overflow-hidden" style={{ height: "71px" }}>
                        {parse(val.about.slice(0, 50))}
                      </p>
                      {/*<button onClick={() => setToggleOneModal(!toggleOneModal)}>Details</button>*/}

                      <button>
                        <NavLink to={`/vacancy-detail/${val._id}`}>
                          Details{" "}
                        </NavLink>
                      </button>
                    </div>
                  </div>
                );
              })}
              
            </Slider>
          </div>

          <div className="job-card-container-sm  d-block d-lg-none">
            {Data.vacancy.map((val, key) => {
              return (
                <Link
                  className="text-decoration-none text-black"
                  to={`/vacancy-detail/${val._id}`}
                >
                  <div className="slide-main" key={key}>
                    <div className="job-card p-3">
                      <div className="top d-flex">
                        <div className="d-flex">
                          <h6>{val.name[0]}</h6>
                          <div className="ms-3">
                            <h5 className="fw-bold">{val.name}</h5>
                            <div className="center d-flex">
                              <p  className="d-none d-md-block">
                                <GoLocation /> {val.location}
                              </p>
                              <p>
                                <TbTie /> Full Time
                              </p>
                            </div>
                          </div>
                        </div>
                        <p className="d-block">
                          <BsBookmark />
                        </p>
                      </div>
                      <div className="center d-flex">
                        <p>
                          <GoLocation /> {val.location}
                        </p>
                      </div>
                      <p className="overflow-hidden mb-0">
                        {
                        // val.about &&
                         parse(val.about.length > 100 ? val.about.slice(0, 100)+"..." : val.about)}
                      </p>
                      {/*<button onClick={() => setToggleOneModal(!toggleOneModal)}>Details</button>*/}

                      <button className="d-none d-md-inline-block">
                        <NavLink to={`/vacancy-detail/${val._id}`}>
                          Details{" "}
                        </NavLink>
                      </button>
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Job Vacancy popup start*/}
        <MDBModal
          show={toggleOneModal}
          setShow={setToggleOneModal}
          tabIndex="-1"
          className="job-popup"
        >
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle className="ps-3">Job Vacancy</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => setToggleOneModal(!toggleOneModal)}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <h5>Graphic Designer</h5>
                <h6>Details</h6>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos. Curabitur tempus urna at
                  turpis condimentum lobortis.
                </p>
                <h6>Role & Responsibility</h6>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos. Curabitur tempus urna at
                  turpis condimentum lobortis.
                </p>
                <h6>Perks & Other Details</h6>
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
                  vulputate libero et velit interdum, ac aliquet odio mattis.
                  Class aptent taciti sociosqu ad litora torquent per conubia
                  nostra, per inceptos himenaeos. Curabitur tempus urna at
                  turpis condimentum lobortis.
                </p>

                <MDBBtn
                  onClick={() => {
                    setToggleOneModal(!toggleOneModal);
                    setTimeout(() => {
                      setToggleTwoModal(!toggleTwoModal);
                    }, 400);
                  }}
                >
                  Apply Job
                </MDBBtn>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>

        {/* Quick Apply popup start */}
        <MDBModal
          show={toggleTwoModal}
          setShow={setToggleTwoModal}
          tabIndex="-1"
          className="apply-popup"
        >
          <MDBModalDialog centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>Quick Apply</MDBModalTitle>
                <MDBBtn
                  className="btn-close"
                  color="none"
                  onClick={() => setToggleTwoModal(!toggleTwoModal)}
                ></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                <Form>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      placeholder="Full name"
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="email"
                      placeholder="Email ID"
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      placeholder="Phone Number"
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control type="text" placeholder="Resume" autoFocus />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormInput">
                    <Form.Control
                      type="text"
                      placeholder="Post what you applying for ?"
                      autoFocus
                    />
                  </Form.Group>
                  <Form.Group className="mb-3" controlId="FormTextarea">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Send Message"
                    />
                  </Form.Group>
                </Form>

                <MDBBtn
                // onClick={() => {
                //   setToggleTwoModal(!toggleTwoModal);
                //   setTimeout(() => {
                //     setToggleOneModal(!toggleOneModal);
                //   }, 400);
                // }}
                >
                  Apply Job
                </MDBBtn>
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    )
  );
};

export default Job;
